import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import SPL from "../redux/poslog/POSLogService";
import {PMS} from "../redux/erplyInstaller/integrations/printingms/main";
import {addErrorAlert} from "../redux/actions";
import {EI} from "../redux/erplyInstaller/main";
import {APP_URL} from "../redux/appConstants";
import {base64Encode} from "../util/helperFunctions";
import {API} from "../redux/actionTypes";
import CTR from "util/receiptTemplate";
import emergencyImg from "./images/emergency.png";

const PMSError = "PMS not available";
const setPMSPort = () => {
    return new Promise((resolve, reject) => {
        if(PMS.port !== false){
            resolve();
            return;
        }
        EI.getIntegration({name: "printing-microservice"}, (config) => {
            PMS.port = config.Port;
            resolve();
        }, reject);
    });
}

const sendNotificationEmail = (sessionInfo, dispatch) =>{
    const emailAddressesConf = localStorage.getItem("emergencyCashDrawerButtonLogEmails");
    if(emailAddressesConf !== null){
        if(emailAddressesConf !== ""){
            let emailAddresses = emailAddressesConf.split(",");
            console.log("Sending log to emails", {emailAddresses});
            initEmailService(sessionInfo, dispatch).then(() => {
                let registerName = sessionInfo.register.match(/\d+/)[0];
                let storeNumber = registerName.substring(0,4);
                let tillNumber = registerName.substring(4,6);
                let storeName = localStorage.getItem("companyName") ?? "Decathlon";
                let date = new Date();
                let message = `
                    <table>
                        <tr><td>Store number</td><td>${storeNumber}</td></tr>
                        <tr><td>Store name</td><td>${storeName}</td></tr>
                        <tr><td>Till number</td><td>${tillNumber}</td></tr>
                        <tr><td>Date</td><td>${date.toLocaleDateString()}</td></tr>
                        <tr><td>Time</td><td>${date.toLocaleTimeString()}</td></tr>
                    </table>
                `;
                sendEmail(storeName, "Important: Emergency Alert at " + storeName, message, emailAddresses).then(() => {

                }, (response) => {
                    console.log("send email failed", {response});
                });
            });
        }
    }
}

const getServiceEndpoints = (sessionInfo, dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({
            type: API,
            payload: {
                data: {
                    request: "getServiceEndpoints",
                    clientCode: sessionInfo.clientCode,
                    sessionKey: sessionInfo.sessionKey
                },
                onSuccess: function (data) {
                    let endpoints = data[0];
                    console.log({endpoints});
                    resolve(endpoints);
                    return {
                        type: "GET_ERPLY_SERVICE_ENDPOINTS_SUCCESS"
                    }
                },
                onFailure: (error) => {
                    reject();
                    return {
                        type: "GET_ERPLY_SERVICE_ENDPOINTS_FAILED"
                    }
                },
                label: 'Get Erply service endpoints'
            }
        });
    });
}
const initEmailService = (sessionInfo, dispatch) => {
    return new Promise((resolve, reject) => {
        if(typeof CTR.emailAPIEndpoint !== "undefined"){
            resolve();
            return;
        }
        getServiceEndpoints(sessionInfo, dispatch).then((endpoints) => {
            CTR.clientCode = sessionInfo.clientCode;
            CTR.sessionKey = sessionInfo.sessionKey;
            CTR.emailAPIEndpoint = endpoints?.ems.url;
            resolve();
        }, reject);
    });
}

const sendEmail = (senderName, subject, message, addresses) => {
    return new Promise(async (resolve, reject) => {
        try {
            let primaryMailbox = await CTR.getPrimaryMailbox();
            let url = CTR.emailAPIEndpoint + "api/v2/message";
            if(process.env.REACT_APP_USE_LOCAL_PROXY === "1"){
                url = APP_URL + "postProxy?u=" + btoa(url)
            }

            let contacts = addresses.reduce((acc, el) => {
                acc.push({
                    address: el,
                    type: "to"
                });
                return acc;
            }, []);
            contacts.push({
                address: primaryMailbox,
                name: senderName,
                type: "from"
            });

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    clientCode: CTR.clientCode,
                    sessionKey: CTR.sessionKey
                },
                body: JSON.stringify({
                    subject: subject,
                    type: "email",
                    bodies: [{contentType: "text/html",content: base64Encode(message)}],
                    contacts
                })
            }).then(response => {
                if (response.status === 201) {
                    resolve(response);
                } else {
                    response.json().then((res) => {
                        reject(res);
                    });
                }
            }, (response) => {
                console.log("Sending email failed", {response});
                reject(response);
            }).catch(error => {
                reject(error);
            });
        }catch (e){
            reject(e);
        }
    });
}

export default function () {
    const currentView = useSelector(state => state.rootReducer.view);
    const dispatch = useDispatch();
    let emergencyButton = null;
    if(currentView === 'login'){
        let showEmergencyCashDrawerButton = localStorage.getItem("showEmergencyCashDrawerButton") === "1";
        if(showEmergencyCashDrawerButton){
            emergencyButton = <div style={{position: "absolute", right: 20, top: 85}}><div
                style={{
                    backgroundImage: "url(" + emergencyImg + ")",
                    width: "100px",
                    height: "100px",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat"
                }}
                onClick={e => {
                    EI.createSession((sessionInfo) => {
                        console.log("EI: createSession", {sessionInfo});
                        if(!SPL.isInit){
                            SPL.init(sessionInfo.posId, sessionInfo.warehouseId, sessionInfo.clientCode, sessionInfo.userInfo.employeeID);
                        }
                        setPMSPort().then(() => {
                            let previousDelayed = SPL.delayed;
                            SPL.delayed = false;
                            SPL.sendOpenCashDrawer((data) => {
                                console.log("Open cash drawer sent");
                                //SPL.delayed gets overwritten right after this callback
                                setTimeout(() => {
                                    SPL.delayed = previousDelayed;
                                },1);

                                PMS.openCashDrawer().then((response) => {
                                    console.log({PMSResponse: response});
                                    if(typeof response.Error !== "undefined"){
                                        dispatch(addErrorAlert(response.Error));
                                    }
                                    sendNotificationEmail(sessionInfo, dispatch);
                                }, () => {
                                    dispatch(addErrorAlert(PMSError));
                                });
                            });
                        }, () => {
                            dispatch(addErrorAlert(PMSError));
                        });
                    }, (error) => {
                        console.log("Failed to create session", {error});

                    });
                }}
            /></div>;
        }
    }
    return emergencyButton;
}